module.exports = __webpack_public_path__ + "web/img/chapter-err-ai.8330eeee.png";